import styled from 'styled-components';

export const GridWrapper = styled.div`
  padding: 0.5rem;
  width: 100%;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex: 1 1 0%;
  text-align: center;
  justify-content: center;
  color: #2d3748;
`;

export const GridControl = styled.span`
  font-size: 0.75rem;
  color: #2d3748;
  padding: 0.15rem;
  cursor: pointer;
`;

export const GridSetupControl = styled(GridControl)`
  position: absolute;
  left: 2px;
  top: 0;
`;

export const GridRemoveControl = styled(GridControl)`
  position: absolute;
  right: 2px;
  top: 0;
`;

export const GridPinControl = styled(GridControl)`
  position: absolute;
  left: 2px;
  bottom: 0;
`;

export const GridControlName = styled(GridControl)`
  position: absolute;
  left: 50%;
  top: 0;
  font-size: 0.75rem;
  padding: 0;
  transform: translate(-50%, 0%);
`;

export const GridControlText = styled.p`
  color: #2d3748;
  text-align: center;
  margin: 0;
`;

export const ControlIcon = styled.div`
  padding: 0.1rem;
  transition: transform 0.5s ease;
  font-size: 16px;
  &:hover {
    transform: scale(1.25);
    color: ${(props: any) => (props.delete ? '#c53030' : 'inherit')};
  }
`;

export const LoadingParagraph = styled.p`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 0.875rem;
`;

export const LoadingError = styled(LoadingParagraph)`
  color: #c53030;
`;

export const JSONEditorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  //  margin-left: -0.75rem;
  //  margin-right: -0.75rem;
  margin-bottom: 1.5rem;
`;

export const JSONEditorSection = styled.div`
  width: 100%;
  color: #4a5568;
`;

export const JSONEditorLabel = styled.label`
  display: block;
  // text-transform: uppercase;
  letter-spacing: 0.025em;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.75rem;
  //  font-weight: 700;
  margin-bottom: 0.5rem;
`;

export const JsonEditorBox = styled.div`
  height: 10rem;
  overflow-y: scroll;
`;

export const WidgetWrapper = styled.div`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  display: block;
`;

export const WidgetText = styled.p`
  font-size: ${(props: any) => (props.size ? props.size : '2.25rem')};
  color: ${(props: any) => (props.color ? props.color : 'inherit')};
  font-weight: ${(props: any) => (props.bold ? '700' : 'inherit')};
  margin: 0;
`;
